/**
 * Arena layout data — the editable single source of the arena's static boxes.
 *
 * Generated by buildDefaultArenaLayout() and rewritten by the in-browser map
 * editor (?editor=1) on Save. Prefer editing via the editor, not by hand.
 */
import type { LayoutBox } from "./arenaLayout";

export const ARENA_LAYOUT_DATA: LayoutBox[] = [
  {
    "id": "perimeter-n",
    "cx": 0,
    "cy": 6,
    "cz": -25,
    "w": 80,
    "h": 12,
    "d": 1,
    "surface": "concrete",
    "render": "wall"
  },
  {
    "id": "perimeter-s",
    "cx": 0,
    "cy": 6,
    "cz": 25,
    "w": 80,
    "h": 12,
    "d": 1,
    "surface": "concrete",
    "render": "wall"
  },
  {
    "id": "perimeter-w",
    "cx": -40,
    "cy": 6,
    "cz": 0,
    "w": 1,
    "h": 12,
    "d": 50,
    "surface": "concrete",
    "render": "wall"
  },
  {
    "id": "perimeter-e",
    "cx": 40,
    "cy": 6,
    "cz": 0,
    "w": 1,
    "h": 12,
    "d": 50,
    "surface": "concrete",
    "render": "wall"
  },
  {
    "id": "locker-t-n",
    "cx": -35.492,
    "cy": 2,
    "cz": -3.475,
    "w": 9,
    "h": 4,
    "d": 1,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-t-s",
    "cx": -35.62,
    "cy": 2,
    "cz": 3.507,
    "w": 9,
    "h": 4,
    "d": 1,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-t-roof",
    "cx": -35.496,
    "cy": 4.1,
    "cz": -0.008,
    "w": 9,
    "h": 0.2,
    "d": 8,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-t-lintel",
    "cx": -31.523,
    "cy": 3.5,
    "cz": 0.007,
    "w": 1,
    "h": 1,
    "d": 8,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-ct-n",
    "cx": 35.492,
    "cy": 2,
    "cz": -3.472,
    "w": 9,
    "h": 4,
    "d": 1,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-ct-s",
    "cx": 35.511,
    "cy": 2,
    "cz": 3.488,
    "w": 9,
    "h": 4,
    "d": 1,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-ct-roof",
    "cx": 35.509,
    "cy": 4.1,
    "cz": 0,
    "w": 9,
    "h": 0.2,
    "d": 8,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "locker-ct-lintel",
    "cx": 31.547,
    "cy": 3.5,
    "cz": 0.005,
    "w": 1,
    "h": 1,
    "d": 8,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "pillar-ct",
    "cx": 10,
    "cy": 6,
    "cz": 0,
    "w": 6,
    "h": 12,
    "d": 6,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-n",
    "cx": -10.365801411290322,
    "cy": 6,
    "cz": -2.6078733841312913,
    "w": 5.268397177419357,
    "h": 12,
    "d": 0.8,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-s",
    "cx": -10.37085080645161,
    "cy": 6,
    "cz": 2.602701612903226,
    "w": 5.282427419354841,
    "h": 12,
    "d": 0.8,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-w-n",
    "cx": -12.6,
    "cy": 6,
    "cz": -2,
    "w": 0.8,
    "h": 12,
    "d": 2,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-w-s",
    "cx": -12.6,
    "cy": 6,
    "cz": 2,
    "w": 0.8,
    "h": 12,
    "d": 2,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-door-lintel",
    "cx": -12.6,
    "cy": 7.5,
    "cz": 0,
    "w": 0.8,
    "h": 9,
    "d": 2,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-e-sill",
    "cx": -7.331602822580644,
    "cy": 0.45,
    "cz": 0.0035000000000000586,
    "w": 0.8000000000000007,
    "h": 2,
    "d": 6.007,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-e-lintel",
    "cx": -7.331602822580644,
    "cy": 8,
    "cz": -0.0039366920656456195,
    "w": 0.8,
    "h": 8,
    "d": 6.007873384131291,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-e-post-n",
    "cx": -7.332,
    "cy": 6,
    "cz": -2.6,
    "w": 0.8,
    "h": 12,
    "d": 0.8,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "troom-e-post-s",
    "cx": -7.332,
    "cy": 6,
    "cz": 2.6,
    "w": 0.8,
    "h": 12,
    "d": 0.8,
    "surface": "concrete",
    "render": "pillar"
  },
  {
    "id": "mid-platform",
    "cx": 0.005391295130803712,
    "cy": 0.75,
    "cz": -0.007873384131291239,
    "w": 12,
    "h": 1.5,
    "d": 12,
    "surface": "concrete",
    "render": "midfloor"
  },
  {
    "id": "crate-t",
    "cx": -20,
    "cy": 0.6,
    "cz": 0,
    "w": 2.5,
    "h": 1.2,
    "d": 2.5,
    "surface": "wood",
    "tint": [
      0.6,
      0.45,
      0.25
    ]
  },
  {
    "id": "crate-ct",
    "cx": 20,
    "cy": 0.6,
    "cz": 0,
    "w": 2.5,
    "h": 1.2,
    "d": 2.5,
    "surface": "wood",
    "tint": [
      0.6,
      0.45,
      0.25
    ]
  },
  {
    "id": "mid-quad-0",
    "cx": -5,
    "cy": 0.6,
    "cz": -5,
    "w": 2.5,
    "h": 1.2,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.5,
      0.5,
      0.5
    ]
  },
  {
    "id": "mid-quad-1",
    "cx": 5,
    "cy": 0.6,
    "cz": -5,
    "w": 2.5,
    "h": 1.2,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.5,
      0.5,
      0.5
    ]
  },
  {
    "id": "mid-quad-2",
    "cx": -5,
    "cy": 0.6,
    "cz": 5,
    "w": 2.5,
    "h": 1.2,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.5,
      0.5,
      0.5
    ]
  },
  {
    "id": "mid-quad-3",
    "cx": 5,
    "cy": 0.6,
    "cz": 5,
    "w": 2.5,
    "h": 1.2,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.5,
      0.5,
      0.5
    ]
  },
  {
    "id": "gate-w-n",
    "cx": -15.986372659122814,
    "cy": 1.5,
    "cz": -11.5,
    "w": 1,
    "h": 3.5,
    "d": 10.5,
    "surface": "concrete",
    "tint": [
      0.45,
      0.45,
      0.5
    ]
  },
  {
    "id": "gate-w-s",
    "cx": -16,
    "cy": 1.5,
    "cz": 11.5,
    "w": 1,
    "h": 3.5,
    "d": 10.5,
    "surface": "concrete",
    "tint": [
      0.45,
      0.45,
      0.5
    ]
  },
  {
    "id": "gate-e-n",
    "cx": 16.005,
    "cy": 1.5,
    "cz": -11.5,
    "w": 1,
    "h": 3.5,
    "d": 10.5,
    "surface": "concrete",
    "tint": [
      0.45,
      0.45,
      0.5
    ]
  },
  {
    "id": "gate-e-s",
    "cx": 16,
    "cy": 1.5,
    "cz": 11.5,
    "w": 1,
    "h": 3.5,
    "d": 10.5,
    "surface": "concrete",
    "tint": [
      0.45,
      0.45,
      0.5
    ]
  },
  {
    "id": "corridor-nw",
    "cx": -15,
    "cy": 1.5,
    "cz": -20.75,
    "w": 4,
    "h": 3,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "corridor-ne",
    "cx": 15,
    "cy": 1.5,
    "cz": -20.75,
    "w": 4,
    "h": 3,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "corridor-n-mid",
    "cx": 0,
    "cy": 1,
    "cz": -20.25,
    "w": 2.5,
    "h": 2,
    "d": 2.5,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "corridor-sw",
    "cx": -15,
    "cy": 1.5,
    "cz": 20.75,
    "w": 4,
    "h": 3,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "corridor-se",
    "cx": 15,
    "cy": 1.5,
    "cz": 20.75,
    "w": 4,
    "h": 3,
    "d": 1.5,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "corridor-s-mid",
    "cx": 0,
    "cy": 1,
    "cz": 20.25,
    "w": 2.5,
    "h": 2,
    "d": 2.5,
    "surface": "wood",
    "tint": [
      0.5,
      0.35,
      0.2
    ]
  },
  {
    "id": "window-sw-sill",
    "cx": -7,
    "cy": 0.45,
    "cz": 13,
    "w": 1,
    "h": 0.9,
    "d": 2,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-sw-lintel",
    "cx": -7,
    "cy": 2.2,
    "cz": 13,
    "w": 1,
    "h": 0.6000000000000001,
    "d": 2,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-sw-side1",
    "cx": -7,
    "cy": 1.25,
    "cz": 11.25,
    "w": 1,
    "h": 2.5,
    "d": 1.5,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-sw-side2",
    "cx": -7,
    "cy": 1.25,
    "cz": 14.75,
    "w": 1,
    "h": 2.5,
    "d": 1.5,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-se-sill",
    "cx": 7,
    "cy": 0.45,
    "cz": 18,
    "w": 1,
    "h": 0.9,
    "d": 2,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-se-lintel",
    "cx": 7,
    "cy": 2.2,
    "cz": 18,
    "w": 1,
    "h": 0.6000000000000001,
    "d": 2,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-se-side1",
    "cx": 7,
    "cy": 1.25,
    "cz": 16.25,
    "w": 1,
    "h": 2.5,
    "d": 1.5,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-se-side2",
    "cx": 7,
    "cy": 1.25,
    "cz": 19.75,
    "w": 1,
    "h": 2.5,
    "d": 1.5,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-nw-sill",
    "cx": -7,
    "cy": 0.45,
    "cz": -20.5,
    "w": 2,
    "h": 0.9,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-nw-lintel",
    "cx": -7,
    "cy": 2.2,
    "cz": -20.5,
    "w": 2,
    "h": 0.6000000000000001,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-nw-side1",
    "cx": -8.75,
    "cy": 1.25,
    "cz": -20.5,
    "w": 1.5,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-nw-side2",
    "cx": -5.25,
    "cy": 1.25,
    "cz": -20.5,
    "w": 1.5,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-ne-sill",
    "cx": 7,
    "cy": 0.45,
    "cz": -20.5,
    "w": 2,
    "h": 0.9,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-ne-lintel",
    "cx": 7,
    "cy": 2.2,
    "cz": -20.5,
    "w": 2,
    "h": 0.6000000000000001,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-ne-side1",
    "cx": 5.25,
    "cy": 1.25,
    "cz": -20.5,
    "w": 1.5,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "window-ne-side2",
    "cx": 8.75,
    "cy": 1.25,
    "cz": -20.5,
    "w": 1.5,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "render": "woodwall"
  },
  {
    "id": "dogdoor-leg",
    "cx": -6.807,
    "cy": 1.25,
    "cz": -11.569,
    "w": 1,
    "h": 2.5,
    "d": 6,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "dogdoor-w",
    "cx": -6.7978749999999994,
    "cy": 1.25,
    "cz": -8.111,
    "w": 1.0417499999999995,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "dogdoor-e",
    "cx": -4.191,
    "cy": 1.25,
    "cz": -8.117,
    "w": 1.25,
    "h": 2.5,
    "d": 1,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "dogdoor-lintel",
    "cx": -5.552,
    "cy": 1.9,
    "cz": -8.106,
    "w": 1.5,
    "h": 1.2,
    "d": 1,
    "surface": "concrete",
    "tint": [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    "id": "block-2",
    "cx": -10.045,
    "cy": 8,
    "cz": 0.033,
    "w": 4.63,
    "h": 8,
    "d": 4.763999999999999,
    "surface": "concrete",
    "render": "pillar"
  }
];
